import React from 'react'
import Aboutmain from '../components/AboutMain/AboutMain'
import AyurvedaAboutSection from '../components/AyurvedaAboutSection/AyurvedaAboutSection'
import WhyChooseAbout from '../components/WhyChooseAbout/WhyChooseAbout'
import TeamSection from '../components/TeamSection/TeamSection'
import AboutBanner from '../components/AboutBanner/AboutBanner'
import AyurvedaFooter from '../components/AyurvedaFooter/AyurvedaFooter'
import ScrollToTop from '../components/ScrollToTop'
import WhatsAppButton from "../components/WhatsAppButton";
import ScrollTop from '../components/ScrollTop'
import { Helmet } from 'react-helmet-async';

export default function About() {
  return (
    <>
       <Helmet>
  <title>
    Our Story | Ayurmoksha Ayurveda Clinic Kerala
  </title>

  <meta
    name="description"
    content="Learn the story of Ayurmoksha Ayurveda Hospital in Kozhikode, Kerala — a healing space rooted in classical Ayurvedic wisdom. Our journey focuses on holistic wellness through Postnatal Care, Rejuvenation Therapy, Hair Treatment, Lifestyle Guidance & Yoga, and Soundarya Kalpa, delivered in a calm, nature-inspired environment."
  />

  <meta
    name="keywords"
    content="Ayurmoksha Our Story, Ayurmoksha Ayurveda Hospital, Ayurveda Hospital in Kozhikode, Ayurveda Hospital in Calicut, Traditional Ayurveda hospital in Kerala, Holistic Healing Ayurveda, Postnatal Care in Kozhikode, Rejuvenation Therapy Kerala, Ayurvedic Hair Treatment Kerala, Lifestyle Guidance in Kerala, Soundarya Kalpa Kerala, Authentic Ayurveda Hospital"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/ourstory" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Our Story | Ayurmoksha Ayurveda Hospital | Authentic Healing in Kerala"
  />
  <meta
    property="og:description"
    content="Discover the story behind Ayurmoksha Ayurveda Hospital in Kozhikode, Kerala. Built on traditional Ayurvedic principles and holistic healing for long-term wellness."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/ourstory"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda Hospital"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Our Story of Ayurmoksha Ayurveda Hospital in Kozhikode Kerala"
  />

  <meta name="author" content="Ayurmoksha Ayurveda Hospital" />
</Helmet>



    <div>
      <ScrollTop/>
        <Aboutmain/>
        <AyurvedaAboutSection/>
        <WhyChooseAbout/>
        <TeamSection/>
        <AboutBanner/>
        <AyurvedaFooter/>
        <ScrollToTop/>
         <WhatsAppButton />

    </div>
    </>
  )
}
